export var AMPLITUDE_ACTION_EVENT_NAMES = {
  COURSE_SAVED: 'Course Saved',
  REMOVE_COURSE: 'Course Unsaved'
};
export var SAVED_COURSES_TRANSLATION_KEY = 'saved-courses';